import { render, staticRenderFns } from "./XCircleIcon.vue?vue&type=template&id=eb4673b4&"
import script from "./XCircleIcon.vue?vue&type=script&lang=js&"
export * from "./XCircleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports